import React from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'
import { CrmTrackView } from '../../../features/crm/crmApi'
import { InfoBox } from '../shared/crmUi'
import { courseTitle, dictLabel, fmtDate, formatPhone, subjectsLine, whenShort } from '../shared/format'

// «Детальдар ▾» у пән басшы: без денег, amoCRM, договора и источника
const HeadTrackInfo: React.FC<{ t: CrmTrackView }> = ({ t }) => {
    const { formatMessage, locale } = useIntl()
    return (
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '10px', whiteSpace: 'normal' }}>
            <InfoBox
                title={formatMessage({ id: 'crmStudent' })}
                rows={[
                    [formatMessage({ id: 'crmFullName' }), t.studentName],
                    [formatMessage({ id: 'crmPhone' }), formatPhone(t.studentPhone)],
                    [formatMessage({ id: 'crmIin' }), t.iin || '-'],
                    [formatMessage({ id: 'crmGrade' }), dictLabel(formatMessage, 'Grade', t.grade)],
                    [formatMessage({ id: 'crmLanguage' }), dictLabel(formatMessage, 'Lang', t.language)],
                ]}
            />
            <InfoBox
                title={formatMessage({ id: 'crmParent' })}
                rows={[
                    [formatMessage({ id: 'crmFullName' }), t.parentName],
                    [formatMessage({ id: 'crmPhone' }), formatPhone(t.parentPhone)],
                ]}
            />
            <InfoBox
                title={formatMessage({ id: 'crmStudy' })}
                rows={[
                    [formatMessage({ id: 'crmCourse' }), courseTitle(t, locale)],
                    [formatMessage({ id: 'crmEndDate' }), fmtDate(t.endDate)],
                    [formatMessage({ id: 'crmAllSubjects' }), subjectsLine(t.allSubjects, locale)],
                    [formatMessage({ id: 'crmLogin' }), t.login || '-'],
                    ...(t.note ? [[formatMessage({ id: 'crmNote' }), t.note] as [string, React.ReactNode]] : []),
                ]}
            />
            <InfoBox
                title={formatMessage({ id: 'crmPath' })}
                rows={[
                    [formatMessage({ id: 'crmRegistered' }), `${whenShort(t.createdAt)}${t.sellerName ? ` · ${t.sellerName}` : ''}`],
                    [formatMessage({ id: 'MODERATOR' }), whenShort(t.approvedAt) || '-'],
                    [formatMessage({ id: 'crmToHead' }), whenShort(t.headAt) || '-'],
                    ...(t.assignedAt
                        ? [[formatMessage({ id: 'crmMentor' }), `${t.mentorName || '-'} · ${whenShort(t.assignedAt)}`] as [string, React.ReactNode]]
                        : []),
                ]}
            />
        </Box>
    )
}

export default HeadTrackInfo
